// removed by extract-text-webpack-plugin
module.exports = {"status":"_1khtrjZj3bDNlhz8xZwWlo","disabled":"_34THfSrQclRq1HhyHUOIgK","norm":"V3dhBPzIzU2otI_gLfDrj","avar":"_2n4nEQ9LXhQ1TCTeFErAfk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/StatusBA/style.css
// module id = 287
// module chunks = 0